// packages/api-client/queries/descriptorsGroups/index.ts
import { useQuery, useMutation, } from "@tanstack/react-query";
export const createDescriptorsGroupsQueries = (requests, queryClient) => ({
    useListDescriptorsGroups: (params, options = {}) => useQuery({
        queryKey: ["descriptors-groups", params],
        queryFn: async ({ queryKey }) => {
            const [_key, params] = queryKey;
            return requests.listDescriptorsGroups(params);
        },
        ...options,
    }),
    useCreateDescriptorsGroup: (options = {}) => useMutation({
        ...options,
        mutationFn: (attrs) => {
            return requests.createDescriptorsGroup(attrs);
        },
        onSuccess: (...args) => {
            queryClient.invalidateQueries({ queryKey: ["descriptors-groups"] });
            options.onSuccess?.(...args);
        },
    }),
});
//# sourceMappingURL=index.js.map